import React from 'react';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '../../hooks';

export const Snackbar = ({ children, ...rest }) => {
	const { colors } = useTheme();

	const useStyles = makeStyles({
		containerRoot: {
			zIndex: '999999  !important',
		},
		info: {
			backgroundColor: `${colors.body} !important`,
			justifyContent: 'center !important',
		},
		error: { backgroundColor: `${colors.bad} !important` },
		success: { backgroundColor: `${colors.good} !important` },
		warning: { backgroundColor: `${colors.warning} !important` },
	});

	const variants = useStyles();

	const snackStyles = {
		containerRoot: variants.containerRoot,
		variantError: variants.error,
		variantInfo: variants.info,
		variantSuccess: variants.success,
		variantWarning: variants.warning,
	};

	return (
		<SnackbarProvider
			classes={snackStyles}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			hideIconVariant
			preventDuplicate
			{...rest}
		>
			{children}
		</SnackbarProvider>
	);
};
